import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Config } from '../../../infrastructure/config';
import { ChangePasswordRequestModel } from '../../../models/requestModels/password/changePasswordRequestModel';
import { CompleteChangePasswordRequestModel } from '../../../models/requestModels/password/completeChangePasswordRequestModel copy';

@Injectable({
  providedIn: 'root'
})
export class ForgottenpasswordService {

  private userInitiateResetPasswordURL : string = Config.api + "user/auth/password_reset";
  private userResetPasswordURL : string = Config.api + "user/auth/password_reset_complete";


  
  constructor(private httpClient: HttpClient) {

  }

  resetPassword(completeChangePasswordRequestModel: CompleteChangePasswordRequestModel, token: string | null) {
    const params = '/' + token;
    return this.httpClient.patch(this.userResetPasswordURL + params, completeChangePasswordRequestModel);


  }

  initiateResetPassword(changePasswordRequestModel: ChangePasswordRequestModel) {
    return this.httpClient.post(this.userInitiateResetPasswordURL, changePasswordRequestModel);
  }
}
